import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
@Injectable()
export class EmailValidateService {
    api_url: string = environment.apiEndPoint;

    constructor(private http: HttpClient) { }
    getToken() {
        return localStorage.getItem(environment.TOKEN_SECRET);
    }
    getEmailValidateAudit(filter: any) {
        const configs = {
            withCredentials: true,
            headers: { Authorization: `Bearer ${this.getToken()}` },
        };
        return this.http.post<any>(this.api_url + 'get-email-validate-audit', filter, configs)
    }
}


// WEBPACK FOOTER //
// ./src/app/services/emailvalidate.service.ts